module.exports = __webpack_public_path__ + "img/의정부역 파스타.b3619e85.png";